import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a0c39d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, "-", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_miezz_input, {
      modelValue: _ctx.label,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.label) = $event)),
      placeholder: "请选择",
      onHandleFocus: _ctx.showModal
    }, null, 8, ["modelValue", "onHandleFocus"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.voyage,
          ref: "form",
          rules: _ctx.rules,
          "label-width": "0px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "max",
              style: {"margin-bottom":"0px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  modelValue: _ctx.voyage.max,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.voyage.max) = $event)),
                  number: true,
                  pattern: "[0-9]",
                  greaterThanNumber: 0,
                  class: "max"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.voyage.min,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.voyage.min) = $event)),
                      number: true,
                      pattern: "[0-9]",
                      greaterThanNumber: 0,
                      class: "min"
                    }, null, 8, ["modelValue"]),
                    _hoisted_1
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.voyage.unit,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.voyage.unit) = $event)),
                      label: _ctx.voyage.unitLabel,
                      "onUpdate:label": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.voyage.unitLabel) = $event)),
                      options: _ctx.EnumVoyageUnitOption,
                      clearable: false
                    }, null, 8, ["modelValue", "label", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}